"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkboxes = void 0;
const react_1 = __importStar(require("react"));
const UiKitLite_1 = require("../UiKitLite");
const Checkboxes = () => {
    const [isChecked1, setIsChecked1] = (0, react_1.useState)(true);
    const [isChecked2, setIsChecked2] = (0, react_1.useState)(true);
    const [isChecked3, setIsChecked3] = (0, react_1.useState)(true);
    const [isChecked4, setIsChecked4] = (0, react_1.useState)(false);
    const [isChecked5, setIsChecked5] = (0, react_1.useState)(true);
    const [isChecked6, setIsChecked6] = (0, react_1.useState)(false);
    const [isChecked7, setIsChecked7] = (0, react_1.useState)(false);
    const columnNames = [
        'Small',
        'Medium',
        'Large',
        'Unselected',
        'Disabled Selected',
        'Disabled Unselected',
        'Indeterminate',
    ];
    const checkboxes = [
        react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Checkbox, { key: 1, isChecked: isChecked1, onChange: isChecked => setIsChecked1(!isChecked), size: 'sm' }),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Checkbox, { key: 2, isChecked: isChecked2, onChange: isChecked => setIsChecked2(!isChecked) }),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Checkbox, { key: 3, isChecked: isChecked3, onChange: isChecked => setIsChecked3(!isChecked), size: 'lg' }),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Checkbox, { key: 4, isChecked: isChecked4, onChange: isChecked => setIsChecked4(!isChecked) }),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Checkbox, { key: 5, isChecked: isChecked5, onChange: isChecked => setIsChecked5(!isChecked), isDisabled: true }),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Checkbox, { key: 6, isChecked: isChecked6, onChange: isChecked => setIsChecked6(!isChecked), isDisabled: true }),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Form.Checkbox, { key: 7, isChecked: isChecked7, onChange: isChecked => setIsChecked7(!isChecked), isIndeterminate: true }),
    ];
    return (react_1.default.createElement("table", { style: {
            width: '100%',
            textAlign: 'left',
            borderCollapse: 'collapse',
        } },
        react_1.default.createElement("colgroup", null, columnNames.map((c, i) => (react_1.default.createElement("col", { key: i, span: 1, style: { width: '100px' } })))),
        react_1.default.createElement(UiKitLite_1.UiKitLite.TableHeader, { columns: columnNames }),
        react_1.default.createElement("tbody", null,
            react_1.default.createElement(UiKitLite_1.UiKitLite.TableRow, null, checkboxes.map((c, i) => (react_1.default.createElement("div", { key: i, style: { display: 'flex', alignItems: 'center' } }, c)))))));
};
exports.Checkboxes = Checkboxes;
